export default __webpack_public_path__ + "static/media/htb-jonathan.a9f185b5.jpg";